const helpers = {
	decode: function(html: string) {
		var txt = document.createElement("textarea");
		txt.innerHTML = html;
		return txt.value;
	},

	formatCurrency(val: string, round: boolean = false) {
		let num = parseFloat(val);

		if (round) {
			num = Math.round(num);
		}

		let numStr = num.toFixed(2);

		var parts = numStr.toString().split(".");
		parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		return "$" + parts.join(".");
	},

	round(number: number, decimalPlaces: number = 2): number {
		//const tenFactor = Math.pow(10, decimalPlaces);
		//return Math.round(number * tenFactor) / tenFactor;
		if (decimalPlaces > 0) {
			return Number(Math.round(parseFloat(number + "e" + decimalPlaces)) + "e-" + decimalPlaces);
		}

		return Math.round(number);
	},

	goToParcelDetail(parcelId: string) {},
};

export default helpers;
